(function () {
  'use strict';

  if (window.rechargeSubscriptionWidgetBridgeInitialized) return;
  window.rechargeSubscriptionWidgetBridgeInitialized = true;

  const PURCHASE_MODE = {
    BUNDLE_ONETIME: 'bundle-onetime',
    SUBSCRIPTION: 'subscription',
  };

  const RECEIVE_ICON = `<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><g stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M16 24L32 16L48 24L32 32L16 24Z"/><path d="M16 24V44L32 52V32"/><path d="M48 24V44L32 52"/><path d="M24 20L40 28"/></g><circle cx="46" cy="44" r="8" fill="white"/><path d="M42 44L45 47L50 40" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
  const CANCEL_ICON = `<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="24" cy="24" r="16" stroke="currentColor" stroke-width="2"/><path d="M18 18L30 30" stroke="currentColor" stroke-width="2"/><path d="M30 18L18 30" stroke="currentColor" stroke-width="2"/></svg>`;
  const PERCENT_ICON = `<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="8" y="8" width="32" height="32" rx="4" stroke="currentColor" stroke-width="2"/><path d="M17 31L31 17" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><circle cx="18.5" cy="18.5" r="2.5" fill="currentColor"/><circle cx="29.5" cy="29.5" r="2.5" fill="currentColor"/></svg>`;
  const INFO_ICON = `<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="24" cy="24" r="16" stroke="currentColor" stroke-width="2"/><path d="M24 20V30" stroke="currentColor" stroke-width="2"/><circle cx="24" cy="16" r="1.5" fill="currentColor"/></svg>`;
  const INFO_ICON_V2 = `<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="24" cy="24" r="14" stroke="currentColor" stroke-width="2"/><circle cx="24" cy="17.5" r="1.8" fill="currentColor"/><path d="M24 22.5V31.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>`;

  const SHADOW_STYLE_ID = 'jp-recharge-shadow-overrides-v5';
  const LEARN_MORE_STYLE_ID = 'jp-rc-learn-more-overrides';
  const BENEFITS_STYLE_ID = 'jp-rc-benefits-overrides-v2';
  const SUB_CONTAINER_STYLE_ID = 'jp-rc-sub-container-layout-v2';
  const SELLING_PLANS_STYLE_ID = 'jp-rc-selling-plans-overrides';
  const V2_SHADOW_STYLE_ID = 'jp-rc-widget-v2-shadow-overrides';
  const V2_BENEFITS_THEME_ID = 'jp-rc-benefits-v2-theme';
  const V2_LEARN_MORE_STYLE_ID = 'jp-rc-learn-more-v2-overrides';
  const V1_DISCOUNT_BENEFIT_STYLE_ID = 'jp-rc-benefits-v1-discount';

  function svgToDataUrl(svg, color) {
    const fillColor = color || '#ffffff';
    const normalized = svg.replace(/currentColor/g, fillColor).replace(/\s+/g, ' ').trim();
    return `url("data:image/svg+xml,${encodeURIComponent(normalized)}")`;
  }

  function isRechargeWidgetV2(element) {
    const container = getProductInfoContainer(element) || document.querySelector('.product__info-container');
    return container?.dataset?.jpRcWidgetV2 === 'true';
  }

  function getV1DiscountBenefitMode(element) {
    if (isRechargeWidgetV2(element)) return null;

    const container = getProductInfoContainer(element) || document.querySelector('.product__info-container');
    if (!container) return null;

    if (container.dataset.jpRcV1OverrideLastBenefit === 'true') return 'override';
    if (container.dataset.jpRcV1AddDiscountBenefit === 'true') return 'add';
    return null;
  }

  function getV2DiscountBenefitMode(element) {
    if (!isRechargeWidgetV2(element)) return null;

    const container = getProductInfoContainer(element) || document.querySelector('.product__info-container');
    if (!container) return null;

    if (container.dataset.jpRcV2OverrideLastBenefit === 'true') return 'override';
    if (container.dataset.jpRcV2AddDiscountBenefit === 'true') return 'add';
    return null;
  }

  function getProductInfoContainer(element) {
    return element?.closest?.('.product__info-container') || document.querySelector('.product__info-container');
  }

  function getRechargeI18n(element) {
    const container =
      getProductInfoContainer(element) ||
      document.querySelector('[data-jp-rc-subscribe-title]') ||
      document.querySelector('.product__info-container');
    const data = container?.dataset || {};

    return {
      subscribeTitle: data.jpRcSubscribeTitle || 'suscríbete y ahorra',
      receiveEveryDays: data.jpRcReceiveEveryDays || 'Recíbelo cada {{ count }} días.',
      cancelAnytime: data.jpRcCancelAnytime || 'Cancela cuando quieras.',
      learnMore: data.jpRcLearnMore || 'Más información.',
      learnMoreUrl: data.jpRcLearnMoreUrl || '/pages/plan-de-suscripcion',
      discountFromSecondHtml:
        data.jpRcDiscountFromSecond || '<strong>15% de dto.</strong> a partir del segundo mes.',
      orChoose: data.jpRcOrChoose || 'o elige la modalidad:',
      subscribeBadge: data.jpRcSubscribeBadge || 'maximiza resultados',
    };
  }

  function formatReceiveEveryDays(template, count) {
    return String(template || '').replace(/\{\{\s*count\s*\}\}/g, String(count));
  }

  function getPurchaseMode(container) {
    const scope = container || document.querySelector('.product__info-container');
    return scope?.dataset?.jpRcPurchaseMode || PURCHASE_MODE.BUNDLE_ONETIME;
  }

  function setPurchaseMode(container, mode) {
    const scope = container || document.querySelector('.product__info-container');
    if (scope) scope.dataset.jpRcPurchaseMode = mode;
  }

  function isSubscriptionMode(container) {
    return getPurchaseMode(container) === PURCHASE_MODE.SUBSCRIPTION;
  }

  function getWidgets(root) {
    const scope = root || document;
    return [...scope.querySelectorAll('recharge-subscription-widget')].filter((widget) => {
      return !getProductInfoContainer(widget)?.querySelector('.jp-buybox-v3');
    });
  }

  function getShadow(widget) {
    return widget?.shadowRoot || null;
  }

  function getPurchaseInput(shadow, value) {
    return shadow?.querySelector(`input[name="purchaseOption"][value="${value}"]`) || null;
  }

  function isSubscriptionSelected(widget) {
    const input = getPurchaseInput(getShadow(widget), 'subscription');
    return !!input?.checked;
  }

  function parsePriceValue(value) {
    if (!value || typeof value !== 'string') return null;
    const matches = value.match(/-?[\d]+(?:[.,]\d{1,3})*/g);
    if (!matches?.length) return null;
    const priceText = matches[matches.length - 1];
    const normalized = priceText.replace(/\./g, '').replace(',', '.');
    const number = Number.parseFloat(normalized);
    return Number.isFinite(number) ? number : null;
  }

  function getSubscriptionDiscountPercent(widget) {
    const shadow = getShadow(widget);
    if (!shadow) return null;

    const originalPriceText = shadow.querySelector('.rc-purchase-option__original-price, .rc-price.strike-through')?.textContent || '';
    const discountedPriceText = shadow.querySelector('.rc-price[part="rc-purchase-option__discounted-price"], .rc-purchase-option__discounted-price')?.textContent || '';

    const originalPrice = parsePriceValue(originalPriceText);
    const discountedPrice = parsePriceValue(discountedPriceText);
    if (!originalPrice || !discountedPrice || originalPrice <= discountedPrice) return null;

    return Math.round(((originalPrice - discountedPrice) / originalPrice) * 100);
  }

  function ensureSubscriptionDiscountBadge(widget) {
    const shadow = getShadow(widget);
    if (!shadow) return false;

    const subscriptionOption = shadow.querySelector('.rc-purchase-option__subscription');
    if (!subscriptionOption) return false;

    const discountPercent = getSubscriptionDiscountPercent(widget);
    let badge = subscriptionOption.querySelector('.jp-rc-subscription-discount-badge');

    if (discountPercent === null) {
      if (badge) badge.remove();
      return false;
    }

    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'jp-rc-subscription-discount-badge';
      subscriptionOption.appendChild(badge);
    }

    badge.textContent = `-${discountPercent}%`;
    return true;
  }

  function getScopedWidgets(element) {
    const container = getProductInfoContainer(element);
    return container ? getWidgets(container) : getWidgets();
  }

  function getCustomUnitRadios(container) {
    const scope = container || document;
    return [...scope.querySelectorAll('.custom-one-time-radio')];
  }

  function getSelectedBundleQuantity(container) {
    const scope = container || document;
    const selected = scope.querySelector('.custom-one-time-radio:checked');
    if (selected?.value) {
      const qty = parseInt(selected.value, 10);
      return Number.isFinite(qty) && qty > 0 ? qty : 1;
    }
    const remembered = parseInt(scope.dataset?.jpRcLastBundleQty || '1', 10);
    return Number.isFinite(remembered) && remembered > 0 ? remembered : 1;
  }

  function getBundleWrapper(container) {
    const scope = container || document;
    return scope.querySelector('#custom-one-time-wrapper');
  }

  function clearBundleSelection(container) {
    getCustomUnitRadios(container).forEach((radio) => {
      radio.checked = false;
    });
    getBundleWrapper(container)?.classList.add('jp-rc-bundle-inactive');
  }

  function restoreBundleSelection(container, quantity) {
    const radios = getCustomUnitRadios(container);
    if (!radios.length) return;

    const qty = String(quantity || getSelectedBundleQuantity(container) || 1);
    const target = radios.find((radio) => radio.value === qty) || radios.find((radio) => radio.value === '1') || radios[0];

    radios.forEach((radio) => {
      radio.checked = radio === target;
    });

    if (container && target?.value) {
      container.dataset.jpRcLastBundleQty = target.value;
    }

    getBundleWrapper(container)?.classList.remove('jp-rc-bundle-inactive');
  }

  let purchaseSyncLock = false;

  function syncQuantities(value, container, options = {}) {
    const { silent = false } = options;
    const scope = container || document;
    scope.querySelectorAll('.quantity__input, input[name="quantity"]').forEach((input) => {
      if (String(input.value) !== String(value)) {
        input.value = String(value);
        if (!silent) {
          input.dispatchEvent(new Event('change', { bubbles: true }));
          input.dispatchEvent(new Event('input', { bubbles: true }));
        }
      }
    });
  }

  function clearSellingPlanInputs(container) {
    const scope = container || document;
    scope.querySelectorAll('input[name="selling_plan"], .selected-selling-plan-id').forEach((input) => {
      input.remove();
    });
  }

  function getProductForms(container) {
    const scope = container || document;
    const productInfo = getProductInfoContainer(scope);
    const forms = new Set();

    if (productInfo) {
      productInfo
        .querySelectorAll('form[is="product-form"], form.main-product-form, form[action*="/cart/add"]')
        .forEach((form) => forms.add(form));
    }

    document
      .querySelectorAll(
        'form[is="product-form"][action*="/cart/add"], form.main-product-form, .sticky-atc-bar form[action*="/cart/add"]'
      )
      .forEach((form) => forms.add(form));

    return [...forms];
  }

  function normalizeAllocations(allocations) {
    if (!Array.isArray(allocations)) return [];
    return allocations.filter((allocation) => allocation?.selling_plan_id && !allocation?.error);
  }

  function getStickyBarVariantAllocations() {
    const stickyScript = document.querySelector('.sticky-atc-bar script[type="application/json"]');
    if (!stickyScript?.textContent?.trim()) return [];

    try {
      const variants = JSON.parse(stickyScript.textContent);
      if (!Array.isArray(variants) || !variants.length) return [];

      const widget = document.querySelector('recharge-subscription-widget');
      const variantId =
        document.querySelector('.product-variant-id, form[is="product-form"] input[name="id"]')?.value ||
        widget?.getAttribute('default-variant-id');

      const variant =
        variants.find((entry) => String(entry.id) === String(variantId)) || variants[0];
      return normalizeAllocations(variant?.selling_plan_allocations);
    } catch (error) {
      console.warn('[jp-recharge] sticky bar variant JSON parse failed', error);
      return [];
    }
  }

  function getSellingPlanAllocations() {
    const stickyAllocations = getStickyBarVariantAllocations();
    if (stickyAllocations.length) return stickyAllocations;

    const variantScript = document.querySelector('variant-selects [data-selected-variant]');
    if (variantScript?.textContent) {
      try {
        const variant = JSON.parse(variantScript.textContent);
        const allocations = normalizeAllocations(variant?.selling_plan_allocations);
        if (allocations.length) return allocations;
      } catch (error) {
        console.warn('[jp-recharge] variant JSON parse failed', error);
      }
    }

    const allocationsScript = document.querySelector('[id^="jp-selling-plan-allocations-"]');
    if (allocationsScript?.textContent) {
      try {
        const allocations = normalizeAllocations(JSON.parse(allocationsScript.textContent));
        if (allocations.length) return allocations;
      } catch (error) {
        console.warn('[jp-recharge] allocations JSON parse failed', error);
      }
    }

    return [];
  }

  function pickRechargeSellingPlanId(allocations) {
    if (!allocations?.length) return null;

    const isLegacyShopifyPlan = (name) => {
      const normalized = (name || '').toLowerCase();
      return normalized.includes('5 semanas') || normalized.includes('20%') || normalized.includes('20 %');
    };

    const rechargeByFullPrice = allocations.find((allocation) => {
      const price = Number(allocation.price);
      const compare = Number(allocation.compare_at_price);
      return compare > 0 && price === compare;
    });
    if (rechargeByFullPrice?.selling_plan_id) {
      return String(rechargeByFullPrice.selling_plan_id);
    }

    const rechargeByName = allocations.find((allocation) => {
      const name = allocation?.selling_plan_name || allocation?.selling_plan?.name || '';
      if (isLegacyShopifyPlan(name)) return false;
      const normalized = name.toLowerCase();
      return normalized.includes('month') || normalized.includes('mes');
    });
    if (rechargeByName?.selling_plan_id) {
      return String(rechargeByName.selling_plan_id);
    }

    const nonLegacy = allocations.filter((allocation) => {
      const name = allocation?.selling_plan_name || allocation?.selling_plan?.name || '';
      return !isLegacyShopifyPlan(name);
    });
    if (nonLegacy.length) {
      const newest = [...nonLegacy].sort(
        (a, b) => Number(b.selling_plan_id) - Number(a.selling_plan_id)
      )[0];
      return String(newest.selling_plan_id);
    }

    if (allocations.length === 1) {
      return String(allocations[0].selling_plan_id);
    }

    const newest = [...allocations].sort((a, b) => Number(b.selling_plan_id) - Number(a.selling_plan_id))[0];
    return newest?.selling_plan_id ? String(newest.selling_plan_id) : null;
  }

  function getSellingPlanIdFromWidget(widget) {
    const shadow = getShadow(widget);
    if (!shadow) return null;

    const select = shadow.querySelector('select.rc-plans-select, select[name*="selling"], select');
    if (select?.value) return String(select.value);

    const checkedPlan = shadow.querySelector(
      '.rc-plans-radio-button[checked], .rc-plans-radio-button[aria-checked="true"], input[type="radio"][name*="plan"]:checked'
    );
    if (checkedPlan?.value) return String(checkedPlan.value);

    const hidden = shadow.querySelector('input[name="selling_plan"]');
    if (hidden?.value) return String(hidden.value);

    const container = getProductInfoContainer(widget);
    const existing = container?.querySelector('input[name="selling_plan"]');
    if (existing?.value) return String(existing.value);

    return pickRechargeSellingPlanId(getSellingPlanAllocations());
  }

  function injectSellingPlanToForms(container, sellingPlanId) {
    if (!sellingPlanId) return false;

    let injected = false;
    getProductForms(container).forEach((form) => {
      let input = form.querySelector('input[name="selling_plan"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'selling_plan';
        input.className = 'jp-rc-selling-plan-input';
        form.appendChild(input);
      }
      if (input.value !== sellingPlanId) {
        input.value = sellingPlanId;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      injected = true;
    });

    return injected;
  }

  function getBuyboxV3Root(container) {
    return container?.querySelector?.('.jp-buybox-v3') || document.querySelector('.jp-buybox-v3');
  }

  function getBuyboxV3Selection(container) {
    const root = getBuyboxV3Root(container);
    const selected = root?.querySelector('.jp-buybox-v3__radio:checked');
    if (!selected) return null;

    const mode = selected.dataset.mode || '';
    let quantity = Math.max(1, Number.parseInt(selected.dataset.quantity || '1', 10));

    // Compra única: respeta el quantity__input del comprador.
    if (mode === 'onetime') {
      const liveInput =
        container?.querySelector?.('.quantity__input') ||
        root?.closest('product-info')?.querySelector('.quantity__input') ||
        document.querySelector('.quantity__input');
      const liveQty = Number.parseInt(liveInput?.value || '', 10);
      if (Number.isFinite(liveQty) && liveQty > 0) quantity = liveQty;
    }

    return {
      mode,
      sellingPlanId: selected.dataset.sellingPlanId || '',
      quantity,
    };
  }

  function syncBuyboxV3BeforeSubmit(container) {
    const selection = getBuyboxV3Selection(container);
    if (!selection) return false;

    if (selection.mode === 'subscription' && selection.sellingPlanId) {
      injectSellingPlanToForms(container, selection.sellingPlanId);
    } else {
      clearSellingPlanInputs(container);
    }

    syncQuantities(selection.quantity, container, { silent: true });
    return true;
  }

  function syncSellingPlanForPurchaseMode(container) {
    if (getBuyboxV3Root(container)) {
      syncBuyboxV3BeforeSubmit(container);
      return;
    }

    if (!isSubscriptionMode(container)) {
      clearSellingPlanInputs(container);
      syncQuantities(getSelectedBundleQuantity(container), container);
      return;
    }

    const widgets = getScopedWidgets(container);
    let sellingPlanId = null;

    widgets.forEach((widget) => {
      sellingPlanId = getSellingPlanIdFromWidget(widget) || sellingPlanId;
    });

    if (!sellingPlanId) {
      sellingPlanId = pickRechargeSellingPlanId(getSellingPlanAllocations());
    }

    injectSellingPlanToForms(container, sellingPlanId);
    syncQuantities(1, container);
  }

  function scheduleSubscriptionFormSync(container) {
    if (getBuyboxV3Root(container)) return;

    syncSellingPlanForPurchaseMode(container);
    [50, 150, 350, 700].forEach((delay) => {
      window.setTimeout(() => syncSellingPlanForPurchaseMode(container), delay);
    });
  }

  function syncRechargePurchaseVisual(widget, value) {
    const shadow = getShadow(widget);
    if (!shadow) return;

    const isSubscription = value === 'subscription';
    const subscriptionInput = getPurchaseInput(shadow, 'subscription');
    const onetimeInput = getPurchaseInput(shadow, 'onetime');
    const subscriptionBlock = shadow.querySelector('.rc-purchase-option__subscription');
    const onetimeBlock = shadow.querySelector(
      '.rc-purchase-option__onetime, .rc-purchase-option.rc-selection__onetime'
    );

    if (subscriptionInput) subscriptionInput.checked = isSubscription;
    if (onetimeInput) onetimeInput.checked = !isSubscription;

    if (subscriptionBlock) {
      if (isSubscription) {
        subscriptionBlock.setAttribute('rc-selected', '');
        subscriptionBlock.removeAttribute('rc-not-selected');
      } else {
        subscriptionBlock.setAttribute('rc-not-selected', '');
        subscriptionBlock.removeAttribute('rc-selected');
      }
    }

    if (onetimeBlock) {
      if (isSubscription) {
        onetimeBlock.setAttribute('rc-not-selected', '');
        onetimeBlock.removeAttribute('rc-selected');
      } else {
        onetimeBlock.setAttribute('rc-selected', '');
        onetimeBlock.removeAttribute('rc-not-selected');
      }
    }

    shadow.querySelectorAll('rc-radio-icon').forEach((icon) => {
      const inSubscription = icon.closest('.rc-purchase-option__subscription');
      if (inSubscription) {
        if (isSubscription) icon.setAttribute('checked', '');
        else icon.removeAttribute('checked');
      }
    });
  }

  function selectPurchaseOption(widget, value, options = {}) {
    const { silent = false } = options;
    const shadow = getShadow(widget);
    const input = getPurchaseInput(shadow, value);
    if (!input) return false;

    if (!input.checked) {
      if (silent) {
        input.checked = true;
        syncRechargePurchaseVisual(widget, value);
      } else {
        input.click();
      }
    } else if (silent) {
      syncRechargePurchaseVisual(widget, value);
    }

    if (!silent) {
      input.dispatchEvent(new Event('change', { bubbles: true }));
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }

    return true;
  }

  function applyOnetimePurchase(container, options = {}) {
    const { skipWidgetSelect = false } = options;
    if (purchaseSyncLock) return;
    if (getBuyboxV3Root(container)) return;

    purchaseSyncLock = true;
    try {
      setPurchaseMode(container, PURCHASE_MODE.BUNDLE_ONETIME);

      if (!skipWidgetSelect) {
        getScopedWidgets(container).forEach((widget) => {
          selectPurchaseOption(widget, 'onetime', { silent: true });
          syncRechargePurchaseVisual(widget, 'onetime');
        });
      } else {
        getScopedWidgets(container).forEach((widget) => syncRechargePurchaseVisual(widget, 'onetime'));
      }

      clearSellingPlanInputs(container);

      const radios = getCustomUnitRadios(container);
      if (radios.length && !radios.some((radio) => radio.checked)) {
        restoreBundleSelection(container, container?.dataset?.jpRcLastBundleQty || '1');
      } else {
        getBundleWrapper(container)?.classList.remove('jp-rc-bundle-inactive');
      }

      syncQuantities(getSelectedBundleQuantity(container), container, { silent: true });
    } finally {
      purchaseSyncLock = false;
    }
  }

  function applySubscriptionPurchase(container, widget) {
    if (purchaseSyncLock) return;
    if (getBuyboxV3Root(container)) return;

    purchaseSyncLock = true;
    try {
      setPurchaseMode(container, PURCHASE_MODE.SUBSCRIPTION);
      const targetWidget = widget || getScopedWidgets(container)[0];
      if (targetWidget) {
        selectPurchaseOption(targetWidget, 'subscription', { silent: true });
        syncRechargePurchaseVisual(targetWidget, 'subscription');
      }
      clearBundleSelection(container);
      syncQuantities(1, container, { silent: true });
      scheduleSubscriptionFormSync(container);
    } finally {
      purchaseSyncLock = false;
    }
  }

  function getDurationText() {
    return document.querySelector('#producto-data')?.dataset?.duracion || '35';
  }

  function ensureShadowStyles(shadow) {
    if (!shadow) return;

    shadow.getElementById('jp-recharge-shadow-overrides')?.remove();
    shadow.getElementById('jp-recharge-shadow-overrides-v3')?.remove();
    shadow.getElementById('jp-recharge-shadow-overrides-v4')?.remove();

    if (shadow.getElementById(SHADOW_STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = SHADOW_STYLE_ID;
    style.textContent = `
      .rc-selection__onetime,
      .rc-purchase-option.rc-selection__onetime {
        display: none !important;
      }
      .rc-purchase-option__subscription .rc-purchase-option__selector rc-radio-icon,
      .rc-purchase-option__subscription rc-radio-icon {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 2rem;
        height: 2rem;
        min-width: 2rem;
      }
      .rc-purchase-option__subscription[rc-not-selected] .rc-purchase-option__sub-container {
        /*display: none !important;*/
      }
      .rc-purchase-option__subscription .rc-purchase-option__sub-container {
        color: #ffffff;
      }
      .rc-purchase-option__subscription[rc-not-selected] .rc-purchase-option__sub-container {
        color: #2237a0;
      }
      /*RSB MAIN SELECTOR */
      .rc-purchase-option__selector_subscription {
        font-size: 0;
        line-height: 0;
      }
      .rc-purchase-option__selector_subscription .jp-rc-title-text {
        font-size: 22px;
        line-height: 1.05;
        font-weight: 600;
        color: inherit;
      }
      .rc-purchase-option__subscription[rc-selected] .rc-purchase-option__selector_subscription .jp-rc-title-text {
        color: inherit;
      }
      .rc-purchase-option__subscription {
        position: relative !important;
        overflow: visible !important;
      }
      .rc-purchase-option__subscription .rc-purchase-option__badge,
      .rc-purchase-option__subscription #rc-subscription-badge {
        position: absolute;
        top: -2.2rem;
        right: 1.6rem;
        z-index: 2;
        display: inline-flex !important;
        align-items: center;
        justify-content: center;
        min-width: 5rem;
        margin: 0;
        padding: 0.8rem 0.9rem;
        border-radius: 999px;
        border: 1px solid #2237a0;
        font-size: 1.3rem;
        font-weight: 700;
        line-height: 1;
        white-space: nowrap;
        pointer-events: none;
        background: #2237a0 !important;
        color: inherit !important;
      }
      .rc-purchase-option__subscription[rc-selected] .rc-purchase-option__badge,
      .rc-purchase-option__subscription[rc-selected] #rc-subscription-badge {
        background: inherit !important;
        color: #2237a0 !important;
        border-color: #2237a0;
      }
      .rc-purchase-option__subscription .rc-purchase-option__label {
        display: flex !important;
        flex-direction: row !important;
        justify-content: space-between !important;
        align-items: center !important;
        width: 100%;
        gap: 1rem;
        margin: 0;
        padding: 11px 18px 10px 10px;
        box-sizing: border-box;
        cursor: pointer;
      }
      .rc-purchase-option__subscription .rc-purchase-option__selector {
        display: flex !important;
        align-items: center !important;
        flex: 1 1 auto;
        min-width: 0;
        gap: 0.8rem;
      }
      .rc-purchase-option__subscription .rc-purchase-option__prices {
        display: inline-flex !important;
        flex-direction: row !important;
        flex-wrap: nowrap !important;
        align-items: baseline !important;
        justify-content: flex-end !important;
        gap: 0.8rem !important;
        flex: 0 0 auto !important;
        margin: 0 0 0 auto !important;
        white-space: nowrap !important;
      }
      .rc-purchase-option__subscription[rc-selected] .rc-purchase-option__prices {
        flex-direction: row !important;
        align-items: baseline !important;
      }
      .rc-purchase-option__subscription .rc-purchase-option__original-price,
      .rc-purchase-option__subscription .strike-through {
        text-decoration: line-through;
        opacity: 0.85;
      }
      .rc-purchase-option__subscription .jp-rc-subscription-discount-badge {
        position: absolute;
        top: -18px;
        right: 1rem;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-width: 3rem;
        padding: 0.35rem 0.65rem;
        border-radius: 1.5rem;
        background: #2237a0;
        color: #fff;
        font-size: 11px;
        font-weight: 700;
        line-height: 1;
        pointer-events: none;
        z-index: 3;
        padding: 9px 8px;
      }
      .rc-purchase-option__subscription .jp-rc-subscription-discount-badge {
        background: #2237a0 !important;
        color: #ffffff !important;
        font-size: 11px;
        border: 1px solid #ffffff;
        top: -16px;
      }
      .rc-purchase-option__subscription[rc-selected] .jp-rc-subscription-discount-badge {
        background: #ffffff !important;
        color: #2237a0 !important;
        font-size: 11px;
        border: 1px solid #2237a0;
        top: -16px;
      }
    `;
    shadow.appendChild(style);
    ensureSubContainerLayout(shadow);
  }

  function ensureSubContainerLayout(shadow) {
    if (!shadow) return;
    shadow.getElementById('jp-rc-sub-container-layout')?.remove();
    if (shadow.getElementById(SUB_CONTAINER_STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = SUB_CONTAINER_STYLE_ID;
    style.textContent = `
      .rc-purchase-option__subscription .rc-purchase-option__sub-container {
        display: flex !important;
        flex-direction: column !important;
        gap: 0.35rem;
        padding: 0 18px 14px 10px;
      }
      .rc-purchase-option__sub-container rc-selling-plans {
        order: -10;
        margin: 0 0 0.2rem;
      }
      .rc-purchase-option__sub-container rc-benefits {
        order: 0;
      }
      .rc-purchase-option__sub-container rc-learn-more {
        order: 10;
      }
      .rc-purchase-option__subscription[rc-not-selected] .rc-purchase-option__sub-container rc-learn-more{
        display:none;
      }
    `;
    shadow.appendChild(style);
  }

  function ensureV2ShadowStyles(widget) {
    const shadow = getShadow(widget);
    if (!shadow || !isRechargeWidgetV2(widget)) return;

    let style = shadow.getElementById(V2_SHADOW_STYLE_ID);
    if (!style) {
      style = document.createElement('style');
      style.id = V2_SHADOW_STYLE_ID;
      shadow.appendChild(style);
    }

    style.textContent = `
      .rc-purchase-option__subscription .rc-purchase-option__selector rc-radio-icon,
      .rc-purchase-option__subscription rc-radio-icon {
        display: none !important;
        width: 0 !important;
        height: 0 !important;
        min-width: 0 !important;
      }
      .rc-purchase-option__subscription[rc-not-selected] .rc-purchase-option__sub-container {
        display: flex !important;
        flex-direction: column !important;
        gap: 0;
        padding: 0 16px 12px !important;
      }
      .rc-purchase-option__subscription[rc-selected] .rc-purchase-option__sub-container {
        gap: 0.2rem;
        padding: 0 16px 12px !important;
      }
      .rc-purchase-option__subscription[rc-not-selected] rc-selling-plans,
      .rc-purchase-option__subscription[rc-not-selected] rc-learn-more {
        display: none !important;
      }
      .rc-purchase-option__subscription[rc-selected] rc-learn-more {
        display: block !important;
      }
      .rc-purchase-option__subscription .rc-purchase-option__label {
        padding: 10px 16px 2px !important;
      }
      .rc-purchase-option__selector_subscription .jp-rc-title-text {
        font-size: 20px;
        line-height: 1.15;
      }
      .rc-purchase-option__subscription .rc-purchase-option__original-price {
        font-size: 18px !important;
      }
      .rc-purchase-option__subscription .rc-purchase-option__discounted-price,
      .rc-purchase-option__subscription .rc-purchase-option__price {
        font-size: 18px !important;
        font-weight: 700 !important;
        color: #1a1a1a !important;
      }
      .rc-purchase-option__subscription[rc-selected] .rc-purchase-option__discounted-price,
      .rc-purchase-option__subscription[rc-selected] .rc-purchase-option__price {
        color: inherit !important;
      }
      .jp-rc-maximiza-badge {
        position: absolute;
        bottom: -11px;
        right: 46px;
        z-index: 3;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border-radius: 4.066px;
        border: 1px solid #333;
        background: #434343;
        color: white;
        font-family: Poppins, sans-serif;
        font-size: 1.1rem;
        font-weight: 400;
        line-height: 1;
        padding: 3px 6px;
        white-space: nowrap;
        pointer-events: none;
        @media (max-width: 768px) {
          right: 34px;
          bottom: -8px;
          font-size: 0.9rem;
          padding: 2px 6px;
        }
      }
      .rc-purchase-option__subscription[rc-selected] .jp-rc-maximiza-badge {
        background: #fff;
        border-color: #2237a0;
        color: #2237a0;
      }
    `;
  }

  function ensureMaximizaBadge(widget) {
    if (!isRechargeWidgetV2(widget)) return;

    const shadow = getShadow(widget);
    const subscriptionOption = shadow?.querySelector('.rc-purchase-option__subscription');
    if (!subscriptionOption) return;

    let badge = subscriptionOption.querySelector('.jp-rc-maximiza-badge');
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'jp-rc-maximiza-badge';
      subscriptionOption.appendChild(badge);
    }

    const label =
      getProductInfoContainer(widget)?.dataset?.jpRcSubscribeBadge ||
      document.querySelector('[data-jp-rc-subscribe-badge]')?.dataset?.jpRcSubscribeBadge ||
      getRechargeI18n(widget).subscribeBadge;
    badge.textContent = label;
  }

  function clearV2DiscountBenefits(benefitsShadow) {
    if (!benefitsShadow) return;

    const ul = benefitsShadow.querySelector('.rc-benefits__list ul');
    if (!ul) return;

    ul.querySelectorAll('li.jp-rc-v2-discount-benefit-extra').forEach((li) => li.remove());
    ul.querySelectorAll('li.jp-rc-v2-discount-benefit-override').forEach((li) => {
      li.classList.remove('jp-rc-v2-discount-benefit-override');
      const text = li.querySelector('.jp-rc-benefit-text');
      if (text?.dataset?.jpRcV2Text === 'dto') {
        delete text.dataset.jpRcV2Text;
      }
    });
  }

  function applyV2DiscountBenefits(widget) {
    const mode = getV2DiscountBenefitMode(widget);
    const benefitsShadow = getBenefitsShadow(widget);
    if (!benefitsShadow) return mode;

    const ul = benefitsShadow.querySelector('.rc-benefits__list ul');
    if (!ul) return mode;

    normalizeBenefitListItems(benefitsShadow);

    if (!mode) {
      clearV2DiscountBenefits(benefitsShadow);
      return null;
    }

    if (mode === 'add') {
      ul.querySelectorAll('li.jp-rc-v2-discount-benefit-override').forEach((li) => {
        li.classList.remove('jp-rc-v2-discount-benefit-override');
        const text = li.querySelector('.jp-rc-benefit-text');
        if (text?.dataset?.jpRcV2Text === 'dto') delete text.dataset.jpRcV2Text;
      });

      const discountHtml = getRechargeI18n(widget).discountFromSecondHtml;
      let extra = ul.querySelector('li.jp-rc-v2-discount-benefit-extra');
      if (!extra) {
        extra = document.createElement('li');
        extra.className = 'jp-rc-v2-discount-benefit-extra';
        const span = document.createElement('span');
        span.className = 'jp-rc-benefit-text';
        span.dataset.jpRcV2Text = 'dto';
        span.innerHTML = discountHtml;
        extra.appendChild(span);
        ul.appendChild(extra);
      } else {
        const span = extra.querySelector('.jp-rc-benefit-text');
        if (span && span.dataset.jpRcV2Text !== 'dto') {
          span.dataset.jpRcV2Text = 'dto';
          span.innerHTML = discountHtml;
        }
      }
      
      // Mover el beneficio extra a la segunda posición
      const items = [...ul.querySelectorAll(':scope > li:not(.jp-rc-v1-discount-benefit-extra)')];
      items.forEach((li, index) => {
        li.style.order = index === 0 ? '1' : '3';
      });
      extra.style.order = '2';

      return mode;
    }

    // override
    ul.querySelectorAll('li.jp-rc-v2-discount-benefit-extra').forEach((li) => li.remove());

    const items = [...ul.querySelectorAll(':scope > li')].filter(
      (li) => !li.classList.contains('jp-rc-v2-discount-benefit-extra')
    );
    const last = items[items.length - 1];
    if (!last) return mode;

    items.forEach((li) => {
      if (li !== last) li.classList.remove('jp-rc-v2-discount-benefit-override');
    });

    last.classList.add('jp-rc-v2-discount-benefit-override');
    let text = last.querySelector('.jp-rc-benefit-text');
    if (!text) {
      text = document.createElement('span');
      text.className = 'jp-rc-benefit-text';
      last.appendChild(text);
    }
    if (text.dataset.jpRcV2Text !== 'dto') {
      text.dataset.jpRcV2Text = 'dto';
      text.innerHTML = getRechargeI18n(widget).discountFromSecondHtml;
    }
    return mode;
  }

  function ensureV1DiscountBenefitStyles(benefitsShadow) {
    if (!benefitsShadow) return;

    const percentIconUrl = svgToDataUrl(PERCENT_ICON);
    let style = benefitsShadow.getElementById(V1_DISCOUNT_BENEFIT_STYLE_ID);
    if (!style) {
      style = document.createElement('style');
      style.id = V1_DISCOUNT_BENEFIT_STYLE_ID;
      benefitsShadow.appendChild(style);
    }

    // Match base benefit row metrics exactly (flex column 3.1rem + icon 2.8rem + gap 0.8rem)
    style.textContent = `
      .rc-benefits__list ul > li.jp-rc-v1-discount-benefit-extra,
      .rc-benefits__list ul > li.jp-rc-v1-discount-benefit-override {
        margin: 0 !important;
        padding: 0 !important;
        padding-left: 0 !important;
        padding-inline-start: 0 !important;
        text-indent: 0 !important;
        gap: 0.8rem !important;
        min-height: 2.8rem !important;
        align-items: center !important;
        font-size: 16px !important;
        line-height: 1.3 !important;
      }
      .rc-benefits__list ul > li.jp-rc-v1-discount-benefit-extra {
        padding-top: 2px !important;
      }
      .rc-benefits__list ul > li.jp-rc-v1-discount-benefit-extra::before,
      .rc-benefits__list ul > li.jp-rc-v1-discount-benefit-override::before {
        content: '' !important;
        position: static !important;
        inset: auto !important;
        transform: none !important;
        float: none !important;
        order: -1;
        flex: 0 0 3.1rem !important;
        display: block !important;
        box-sizing: border-box;
        width: 2.8rem !important;
        height: 2.8rem !important;
        min-width: 2.8rem !important;
        margin: 0 !important;
        padding: 0 !important;
        border: none !important;
        background-color: transparent !important;
        /*background-image: ${percentIconUrl} !important;*/
         -webkit-mask-image: ${percentIconUrl} !important;
        mask-image: ${percentIconUrl} !important;
        -webkit-mask-repeat: no-repeat;
        mask-repeat: no-repeat;

        -webkit-mask-position: center;
        mask-position: center;

        -webkit-mask-size: contain;
        mask-size: contain;
        background-color: currentColor!important;
      }
      .rc-benefits__list ul > li.jp-rc-v1-discount-benefit-extra .jp-rc-benefit-text,
      .rc-benefits__list ul > li.jp-rc-v1-discount-benefit-override .jp-rc-benefit-text {
        flex: 1 1 auto;
        min-width: 0;
        font-size: 16px !important;
        line-height: 1.3 !important;
      }
      .rc-benefits__list ul > li .jp-rc-benefit-text strong {
        font-weight: 700;
      }
    `;
  }

  function clearV1DiscountBenefits(benefitsShadow) {
    if (!benefitsShadow) return;

    const ul = benefitsShadow.querySelector('.rc-benefits__list ul');
    if (!ul) return;

    ul.querySelectorAll('li.jp-rc-v1-discount-benefit-extra').forEach((li) => li.remove());
    ul.querySelectorAll('li.jp-rc-v1-discount-benefit-override').forEach((li) => {
      li.classList.remove('jp-rc-v1-discount-benefit-override');
      const text = li.querySelector('.jp-rc-benefit-text');
      if (text?.dataset?.jpRcV1Dto === 'true') {
        delete text.dataset.jpRcV1Dto;
      }
    });
    benefitsShadow.getElementById(V1_DISCOUNT_BENEFIT_STYLE_ID)?.remove();
  }

  function applyV1DiscountBenefits(widget) {
    const mode = getV1DiscountBenefitMode(widget);
    const benefitsShadow = getBenefitsShadow(widget);
    if (!benefitsShadow) return;

    if (!mode) {
      clearV1DiscountBenefits(benefitsShadow);
      return;
    }

    const ul = benefitsShadow.querySelector('.rc-benefits__list ul');
    if (!ul) return;

    normalizeBenefitListItems(benefitsShadow);
    ensureV1DiscountBenefitStyles(benefitsShadow);

    if (mode === 'add') {
      ul.querySelectorAll('li.jp-rc-v1-discount-benefit-override').forEach((li) => {
        li.classList.remove('jp-rc-v1-discount-benefit-override');
        const text = li.querySelector('.jp-rc-benefit-text');
        if (text?.dataset?.jpRcV1Dto === 'true') delete text.dataset.jpRcV1Dto;
      });

      const discountHtml = getRechargeI18n(widget).discountFromSecondHtml;
      let extra = ul.querySelector('li.jp-rc-v1-discount-benefit-extra');
      if (!extra) {
        extra = document.createElement('li');
        extra.className = 'jp-rc-v1-discount-benefit-extra';
        const span = document.createElement('span');
        span.className = 'jp-rc-benefit-text';
        span.dataset.jpRcV1Dto = 'true';
        span.innerHTML = discountHtml;
        extra.appendChild(span);
        ul.appendChild(extra);
      } else {
        const span = extra.querySelector('.jp-rc-benefit-text');
        if (span && span.dataset.jpRcV1Dto !== 'true') {
          span.dataset.jpRcV1Dto = 'true';
          span.innerHTML = discountHtml;
        }
      }

      // Mover el beneficio extra a la segunda posición
      const items = [...ul.querySelectorAll(':scope > li:not(.jp-rc-v1-discount-benefit-extra)')];
      items.forEach((li, index) => {
        li.style.order = index === 0 ? '1' : '3';
      });
      extra.style.order = '2';

      return;
    }

    // mode === 'override' (prevalece sobre add)
    ul.querySelectorAll('li.jp-rc-v1-discount-benefit-extra').forEach((li) => li.remove());

    const items = [...ul.querySelectorAll(':scope > li')];
    const last = items[items.length - 1];
    if (!last) return;

    items.forEach((li) => {
      if (li !== last) li.classList.remove('jp-rc-v1-discount-benefit-override');
    });

    last.classList.add('jp-rc-v1-discount-benefit-override');
    let text = last.querySelector('.jp-rc-benefit-text');
    if (!text) {
      text = document.createElement('span');
      text.className = 'jp-rc-benefit-text';
      last.appendChild(text);
    }
    if (text.dataset.jpRcV1Dto !== 'true') {
      text.dataset.jpRcV1Dto = 'true';
      text.innerHTML = getRechargeI18n(widget).discountFromSecondHtml;
    }
  }

  function syncBenefitsV2Theme(widget, selected) {
    if (!isRechargeWidgetV2(widget)) return;

    const benefitsShadow = getBenefitsShadow(widget);
    if (!benefitsShadow) return;

    normalizeBenefitListItems(benefitsShadow);
    const mode = applyV2DiscountBenefits(widget);

    const color = selected ? '#ffffff' : '#2237a0';
    const receiveIconUrl = svgToDataUrl(RECEIVE_ICON, color);
    const cancelIconUrl = svgToDataUrl(CANCEL_ICON, color);
    const percentIconUrl = svgToDataUrl(PERCENT_ICON, color);

    const receiveIconUrlBlue = svgToDataUrl(RECEIVE_ICON, '#2237a0');
    const cancelIconUrlBlue = svgToDataUrl(CANCEL_ICON, '#2237a0');
    const percentIconUrlBlue = svgToDataUrl(PERCENT_ICON, '#2237a0');

    let theme = benefitsShadow.getElementById(V2_BENEFITS_THEME_ID);
    if (!theme) {
      theme = document.createElement('style');
      theme.id = V2_BENEFITS_THEME_ID;
      benefitsShadow.appendChild(theme);
    }

    const hideExtraNative =
      mode === 'add'
        ? `
      .rc-benefits__list ul > li:nth-child(n+3):not(.jp-rc-v2-discount-benefit-extra) {
        display: none !important;
      }
      .rc-benefits__list ul > li.jp-rc-v2-discount-benefit-extra {
        display: flex !important;
        padding-top: 2px !important;
      }
      .rc-benefits__list ul > li:nth-child(2)::before {
       /* background-image: ${cancelIconUrl} !important;*/
        -webkit-mask-image: ${cancelIconUrl} !important;
        mask-image: ${cancelIconUrl} !important;
        -webkit-mask-repeat: no-repeat;
        mask-repeat: no-repeat;

        -webkit-mask-position: center;
        mask-position: center;

        -webkit-mask-size: contain;
        mask-size: contain;
        background-color: currentColor!important;
      }
      .rc-benefits__list ul > li.jp-rc-v2-discount-benefit-extra::before {
        /*background-image: ${percentIconUrl} !important;*/
        -webkit-mask-image: ${percentIconUrl} !important;
        mask-image: ${percentIconUrl} !important;
        -webkit-mask-repeat: no-repeat;
        mask-repeat: no-repeat;

        -webkit-mask-position: center;
        mask-position: center;

        -webkit-mask-size: contain;
        mask-size: contain;
        background-color: currentColor!important;
      }
    `
        : `
      .rc-benefits__list ul > li:nth-child(n+3) {
        display: none !important;
      }
      .rc-benefits__list ul > li:nth-child(2)::before {
        /*background-image: ${mode === 'override' ? percentIconUrl : cancelIconUrl} !important;*/
        -webkit-mask-image: ${mode === 'override' ? percentIconUrl : cancelIconUrl} !important;
        mask-image: ${mode === 'override' ? percentIconUrl : cancelIconUrl} !important;
        -webkit-mask-repeat: no-repeat;
        mask-repeat: no-repeat;

        -webkit-mask-position: center;
        mask-position: center;

        -webkit-mask-size: contain;
        mask-size: contain;
        background-color: currentColor!important;
      }
      .rc-benefits__list ul > li.jp-rc-v2-discount-benefit-override::before {
        /*background-image: ${percentIconUrl} !important;*/
        -webkit-mask-image: ${percentIconUrl} !important;
        mask-image: ${percentIconUrl} !important;
        -webkit-mask-repeat: no-repeat;
        mask-repeat: no-repeat;

        -webkit-mask-position: center;
        mask-position: center;

        -webkit-mask-size: contain;
        mask-size: contain;
        background-color: currentColor!important;
      }
    `;

    theme.textContent = `
      .rc-benefits__list {
        color: inherit!important;
        margin: 0 !important;
        padding: 0 !important;
      }
      .rc-benefits__list ul {
        gap: 0 !important;
      }
      .rc-benefits__list ul > li {
        color: inherit!important;
        min-height: 2.2rem !important;
        gap: 0.55rem !important;
        font-size: 15px !important;
        line-height: 1.25 !important;
      }
      .rc-benefits__list ul > li .jp-rc-benefit-text {
        font-size: 15px !important;
        line-height: 1.25 !important;
      }
      .rc-benefits__list ul > li .jp-rc-benefit-text strong {
        font-weight: 700;
      }
      .rc-benefits__list ul > li::before {
        flex-basis: 2.2rem !important;
        width: 2.2rem !important;
        height: 2.2rem !important;
        min-width: 2.2rem !important;
      }
      .rc-benefits__list ul > li:nth-child(1)::before {
        flex-basis: 2.4rem !important;
        width: 2.4rem !important;
        height: 2.4rem !important;
        min-width: 2.4rem !important;
        /*background-image: ${receiveIconUrl} !important;*/
        -webkit-mask-image: ${receiveIconUrl} !important;
        mask-image: ${receiveIconUrl} !important;
      }
      
        
      ${hideExtraNative}
    `;
  }

  function ensureSellingPlansStyles(plansShadow) {
    if (!plansShadow || plansShadow.getElementById(SELLING_PLANS_STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = SELLING_PLANS_STYLE_ID;
    style.textContent = `
      :host {
        display: block;
        width: 100%;
      }
      .rc-plans-button-group {
        border: 0;
        margin: 0;
        padding: 0;
        min-width: 0;
      }
      .rc-plans__label {
        display: none !important;
        height: 0;
        overflow: hidden;
        margin: 0;
        padding: 0;
      }
      .rc-plans-button-group label {
        display: block;
        margin: 0;
        padding: 0;
        cursor: default;
      }
      .rc-plans-button-group input[type="radio"] {
        position: absolute;
        opacity: 0;
        pointer-events: none;
        width: 0;
        height: 0;
      }
      .rc-plans-button,
      .rc-plans-button[data-checked] {
        display: block;
        background: transparent !important;
        border: none !important;
        box-shadow: none !important;
        outline: none !important;
        padding: 0 !important;
        margin: 0 !important;
        min-height: 0 !important;
        border-radius: 0 !important;
        color: #ffffff !important;
      }
      .rc-plans-button__discount {
        display: none !important;
        visibility: hidden !important;
        height: 0 !important;
        overflow: hidden !important;
      }
      .rc-plans-button__interval {
        display: block;
        color: #ffffff !important;
        font-size: clamp(1.55rem, 2vw, 2rem);
        font-weight: 600;
        line-height: 1.3;
        display: none;
      }
      .rc-plans-button__interval::after {
        content: ':';
      }
    `;
    plansShadow.appendChild(style);
  }

  function enhanceSellingPlans(widget) {
    const widgetShadow = getShadow(widget);
    if (!widgetShadow) return false;

    const plans = widgetShadow.querySelector('rc-selling-plans');
    if (!plans?.shadowRoot) return false;

    ensureSellingPlansStyles(plans.shadowRoot);
    return true;
  }

  function scheduleSellingPlansEnhancement(widget) {
    [0, 50, 100, 200, 500, 1000, 2000].forEach((delay) => {
      window.setTimeout(() => enhanceSellingPlans(widget), delay);
    });
  }

  function shouldShowModalidadTitle(element) {
    const container = getProductInfoContainer(element) || document.querySelector('.product__info-container');
    if (!container) return true;
    return container.dataset.jpRcShowModalidadTitle !== 'false';
  }

  function ensureModalidadHeading(widget) {
    if (!widget) return;

    const existingHeading = widget.previousElementSibling?.classList?.contains('jp-rc-modalidad-title')
      ? widget.previousElementSibling
      : null;

    if (!shouldShowModalidadTitle(widget)) {
      existingHeading?.remove();
      return;
    }

    const container = getProductInfoContainer(widget);
    const existingTitle = container?.querySelector('.custom-units-title.bottom-title');
    const titleText = existingTitle?.textContent?.trim() || getRechargeI18n(widget).orChoose;

    let heading = existingHeading;
    if (!heading) {
      heading = document.createElement('p');
      heading.className = 'jp-rc-modalidad-title';
      widget.insertAdjacentElement('beforebegin', heading);
    }

    heading.textContent = titleText;
  }

  function ensureLearnMoreStyles(learnMoreShadow) {
    if (!learnMoreShadow || learnMoreShadow.getElementById(LEARN_MORE_STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = LEARN_MORE_STYLE_ID;
    style.textContent = `
      .rc-learn-more {
        display: block;        
        padding: 0;
        margin-top: .1rem;        
        margin-left: 2px;
      }
      .rc-learn-more__trigger {
        display: inline-flex;
        align-items: center;
        gap: 0.8rem;
        margin: 0;
        padding: 0;
        border: none;
        background: transparent;
        color: inherit !important;
        font-family: inherit;
        font-size: 16px;
        line-height: 1.3;
        font-weight: 400;
        text-align: left;
        text-decoration: underline;
        text-underline-offset: 2px;
        cursor: pointer;
        -webkit-appearance: none;
        appearance: none;
      }
      .rc-learn-more__trigger:hover,
      .rc-learn-more__trigger:focus {
        color: inherit !important;
        text-decoration: underline;
      }
      .jp-rc-learn-more-icon {
        display: inline-flex;
        flex-shrink: 0;
        align-items: center;
        justify-content: center;
        width: 2.8rem;
        min-width: 2.8rem;
        height: 2.8rem;
        color: inherit;
      }
      .jp-rc-learn-more-icon svg {
        width: 2.8rem;
        height: 2.8rem;
        display: block;
      }
    `;
    learnMoreShadow.appendChild(style);
  }

  function ensureLearnMoreV2Styles(learnMoreShadow) {
    if (!learnMoreShadow) return;

    let style = learnMoreShadow.getElementById(V2_LEARN_MORE_STYLE_ID);
    if (!style) {
      style = document.createElement('style');
      style.id = V2_LEARN_MORE_STYLE_ID;
      learnMoreShadow.appendChild(style);
    }

    style.textContent = `
      .rc-learn-more {
        margin: 0 !important;
        padding: 0 !important;
      }
      .rc-learn-more__trigger {
        gap: 0.55rem !important;
        font-size: 15px !important;
        line-height: 1.25 !important;
        min-height: 2.2rem;
      }
      .jp-rc-learn-more-icon {
        width: 2.2rem !important;
        min-width: 2.2rem !important;
        height: 2.2rem !important;
      }
      .jp-rc-learn-more-icon svg {
        width: 2.2rem !important;
        height: 2.2rem !important;
      }
    `;
  }

  function decorateLearnMoreTrigger(learnMoreShadow, widget) {
    const trigger = learnMoreShadow?.querySelector('.rc-learn-more__trigger');
    if (!trigger) return;

    const useV2 = isRechargeWidgetV2(widget);
    const iconHtml = useV2 ? INFO_ICON_V2 : INFO_ICON;
    let iconWrap = trigger.querySelector('.jp-rc-learn-more-icon');

    if (!iconWrap) {
      iconWrap = document.createElement('span');
      iconWrap.className = 'jp-rc-learn-more-icon';
      iconWrap.setAttribute('aria-hidden', 'true');
      trigger.prepend(iconWrap);
    }

    if (iconWrap.dataset.jpRcIcon !== (useV2 ? 'v2' : 'v1')) {
      iconWrap.dataset.jpRcIcon = useV2 ? 'v2' : 'v1';
      iconWrap.innerHTML = iconHtml;
    }
  }

  function enhanceLearnMore(widget) {
    const widgetShadow = getShadow(widget);
    const learnMoreEl = widgetShadow?.querySelector('rc-learn-more');
    const learnMoreShadow = learnMoreEl?.shadowRoot;
    if (!learnMoreShadow) return false;

    ensureLearnMoreStyles(learnMoreShadow);
    if (isRechargeWidgetV2(widget)) {
      ensureLearnMoreV2Styles(learnMoreShadow);
    }
    decorateLearnMoreTrigger(learnMoreShadow, widget);
    return true;
  }

  function scheduleLearnMoreEnhancement(widget) {
    enhanceLearnMore(widget);
    window.setTimeout(() => enhanceLearnMore(widget), 250);
  }

  function normalizeBenefitListItems(benefitsShadow) {
    benefitsShadow.querySelectorAll('.rc-benefits__list ul > li').forEach((li) => {
      if (li.querySelector('.jp-rc-benefit-text')) return;

      const text = Array.from(li.childNodes)
        .filter((node) => node.nodeType === Node.TEXT_NODE)
        .map((node) => node.textContent.trim())
        .filter(Boolean)
        .join(' ');

      Array.from(li.childNodes).forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE) node.remove();
      });

      if (!text) return;

      const label = document.createElement('span');
      label.className = 'jp-rc-benefit-text';
      label.textContent = text;
      li.appendChild(label);
    });
  }

  function ensureBenefitsStyles(benefitsShadow) {
    if (!benefitsShadow) return;

    if (benefitsShadow.getElementById(BENEFITS_STYLE_ID)) return;

    benefitsShadow.getElementById('jp-rc-benefits-overrides')?.remove();

    const receiveIconUrl = svgToDataUrl(RECEIVE_ICON);
    const cancelIconUrl = svgToDataUrl(CANCEL_ICON);
    const percentIconUrl = svgToDataUrl(PERCENT_ICON);    

    const style = document.createElement('style');
    style.id = BENEFITS_STYLE_ID;
    style.textContent = `
      .rc-benefits__list {
        display: block;
        margin: 0;
        padding: 0;
        color: inherit;
      }
      .rc-benefits__list ul {
        list-style: none;
        margin: 0;
        padding: 0;
        display: flex;
        flex-direction: column;
        gap: 0.2rem;
      }
      .rc-benefits__list ul > li {
        position: relative !important;
        display: flex !important;
        flex-direction: row !important;
        flex-wrap: nowrap;
        align-items: center;
        gap: 0.8rem;
        margin: 0 !important;
        padding: 0 !important;
        padding-left: 0 !important;
        padding-inline-start: 0 !important;
        text-indent: 0 !important;
        list-style: none !important;
        color: inherit;
        font-size: 16px;
        line-height: 1.3;
        min-height: 2.8rem;
      }
      .rc-benefits__list ul > li .jp-rc-benefit-text {
        flex: 1 1 auto;
        min-width: 0;
      }
      .rc-benefits__list ul > li::before {
        content: '' !important;
        position: static !important;
        inset: auto !important;
        left: auto !important;
        top: auto !important;
        right: auto !important;
        bottom: auto !important;
        transform: none !important;
        float: none !important;
        order: -1;
        flex: 0 0 3.1rem;
        display: block !important;
        box-sizing: border-box;
        width: 2.8rem;
        height: 2.8rem;
        min-width: 2.8rem;
        margin: 0 !important;
        padding: 0 !important;
        border: none !important;
        border-radius: 0 !important;
        background-color: transparent !important;
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        color: inherit !important;
        /*-webkit-mask: none !important;
        mask: none !important;*/
      }
      .rc-benefits__list ul > li:nth-child(1)::before {
        flex-basis: 3.1rem;
        width: 3.1rem;
        height: 3.1rem;
        min-width: 3.1rem;
        /*background-image: ${receiveIconUrl} !important;*/
        -webkit-mask-image: ${receiveIconUrl} !important;
        mask-image: ${receiveIconUrl} !important;
        -webkit-mask-repeat: no-repeat;
        mask-repeat: no-repeat;

        -webkit-mask-position: center;
        mask-position: center;

        -webkit-mask-size: contain;
        mask-size: contain;
        background-color: currentColor!important;
      }
      .rc-benefits__list ul > li:nth-child(2)::before {
        /*background-image: ${cancelIconUrl} !important;*/
        -webkit-mask-image: ${cancelIconUrl} !important;
        mask-image: ${cancelIconUrl} !important;
        -webkit-mask-repeat: no-repeat;
        mask-repeat: no-repeat;

        -webkit-mask-position: center;
        mask-position: center;

        -webkit-mask-size: contain;
        mask-size: contain;
        background-color: currentColor!important;
      }
    `;
    benefitsShadow.appendChild(style);
  }

  function getBenefitsShadow(widget) {
    const widgetShadow = getShadow(widget);
    if (!widgetShadow) return null;

    const benefitsEl = widgetShadow.querySelector('rc-benefits');
    if (benefitsEl?.shadowRoot) return benefitsEl.shadowRoot;

    if (widgetShadow.querySelector('.rc-benefits__list ul > li')) return widgetShadow;

    return null;
  }

  function enhanceBenefits(widget) {
    const benefitsShadow = getBenefitsShadow(widget);
    if (!benefitsShadow) return false;

    ensureBenefitsStyles(benefitsShadow);
    normalizeBenefitListItems(benefitsShadow);
    if (isRechargeWidgetV2(widget)) {
      syncBenefitsV2Theme(widget, isSubscriptionMode(getProductInfoContainer(widget)));
    } else {
      applyV1DiscountBenefits(widget);
    }
    return true;
  }

  function scheduleBenefitsEnhancement(widget) {
    enhanceBenefits(widget);
    [80, 200, 500].forEach((delay) => {
      window.setTimeout(() => enhanceBenefits(widget), delay);
    });
  }

  function ensureSubscribeExtras(widget) {
    if (!widget || widget.querySelector('.jp-rc-subscribe-extras')) return;

    const i18n = getRechargeI18n(widget);
    const duration = getDurationText();
    const receiveText = formatReceiveEveryDays(i18n.receiveEveryDays, duration);
    const extras = document.createElement('div');
    extras.className = 'jp-rc-subscribe-extras';
    extras.setAttribute('aria-hidden', 'true');

    const receive = document.createElement('span');
    receive.className = 'jp-rc-subscribe-item item-receive';
    receive.innerHTML = RECEIVE_ICON;
    const receiveLabel = document.createElement('span');
    receiveLabel.textContent = receiveText;
    receive.appendChild(receiveLabel);

    const cancel = document.createElement('span');
    cancel.className = 'jp-rc-subscribe-item item-cancel';
    cancel.innerHTML = CANCEL_ICON;
    const cancelLabel = document.createElement('span');
    cancelLabel.textContent = i18n.cancelAnytime;
    cancel.appendChild(cancelLabel);

    const info = document.createElement('span');
    info.className = 'jp-rc-subscribe-item item-info';
    info.innerHTML = INFO_ICON;
    const infoLink = document.createElement('a');
    infoLink.href = i18n.learnMoreUrl;
    infoLink.textContent = i18n.learnMore;
    info.appendChild(infoLink);

    extras.appendChild(receive);
    extras.appendChild(cancel);
    extras.appendChild(info);
    widget.appendChild(extras);
  }

  function updateSubscriptionLabel(widget) {
    const shadow = getShadow(widget);
    if (!shadow) return;

    const selector = shadow.querySelector('.rc-purchase-option__subscription .rc-purchase-option__selector');
    if (!selector) return;

    const labelText = getRechargeI18n(widget).subscribeTitle;

    Array.from(selector.childNodes).forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
        node.textContent = '';
      }
    });

    let title = selector.querySelector('.jp-rc-title-text');
    if (!title) {
      title = document.createElement('span');
      title.className = 'jp-rc-title-text';
      const icon = selector.querySelector('rc-radio-icon');
      if (icon?.nextSibling) {
        selector.insertBefore(title, icon.nextSibling);
      } else {
        selector.appendChild(title);
      }
    }
    title.textContent = labelText;
  }

  const widgetStateUpdateTimers = new WeakMap();
  const INIT_GRACE_MS = 2800;

  function markInitGrace(container, widget) {
    const until = String(Date.now() + INIT_GRACE_MS);
    if (container) container.dataset.jpRcInitUntil = until;
    if (widget) widget.dataset.jpRcInitUntil = until;
  }

  function isWithinInitGrace(scope) {
    const until = Number(scope?.dataset?.jpRcInitUntil || 0);
    return until > Date.now();
  }

  function queueWidgetStateUpdate(widget) {
    const previous = widgetStateUpdateTimers.get(widget);
    if (previous) window.clearTimeout(previous);

    widgetStateUpdateTimers.set(
      widget,
      window.setTimeout(() => {
        widgetStateUpdateTimers.delete(widget);
        updateWidgetState(widget);
      }, 120)
    );
  }

  function initWidgetPresentation(widget) {
    const shadow = getShadow(widget);
    if (!shadow) return false;

    ensureShadowStyles(shadow);
    ensureModalidadHeading(widget);
    updateSubscriptionLabel(widget);
    ensureV2ShadowStyles(widget);
    ensureMaximizaBadge(widget);

    if (!shadow.querySelector('rc-benefits') || !shadow.querySelector('rc-learn-more')) {
      return false;
    }

    ensureSubscriptionDiscountBadge(widget);
    enhanceBenefits(widget);
    enhanceLearnMore(widget);
    enhanceSellingPlans(widget);
    ensureSubContainerLayout(shadow);
    syncBenefitsV2Theme(widget, isSubscriptionMode(getProductInfoContainer(widget)));
    widget.dataset.jpRcPresentationReady = 'true';
    return true;
  }

  function scheduleWidgetPresentation(widget) {
    [0, 300, 700, 1500, 3000].forEach((delay) => {
      window.setTimeout(() => {
        if (widget.dataset.jpRcPresentationReady === 'true' && isPresentationIntact(widget)) return;
        if (widget.dataset.jpRcPresentationReady === 'true' && !isPresentationIntact(widget)) {
          delete widget.dataset.jpRcPresentationReady;
        }
        initWidgetPresentation(widget);
      }, delay);
    });
  }

  function isPresentationIntact(widget) {
    const shadow = getShadow(widget);
    if (!shadow) return false;
    if (!shadow.getElementById(SHADOW_STYLE_ID)) return false;
    if (!shadow.querySelector('.jp-rc-title-text')) return false;
    if (!shadow.querySelector('rc-benefits') || !shadow.querySelector('rc-learn-more')) return false;

    const benefitsShadow = getBenefitsShadow(widget);
    if (isRechargeWidgetV2(widget)) {
      const mode = getV2DiscountBenefitMode(widget);
      if (mode === 'add' && !benefitsShadow?.querySelector('li.jp-rc-v2-discount-benefit-extra')) {
        return false;
      }
      if (
        mode === 'override' &&
        !benefitsShadow?.querySelector('li.jp-rc-v2-discount-benefit-override .jp-rc-benefit-text[data-jp-rc-v2-text="dto"]')
      ) {
        return false;
      }
    } else {
      const mode = getV1DiscountBenefitMode(widget);
      if (mode === 'add' && !benefitsShadow?.querySelector('li.jp-rc-v1-discount-benefit-extra')) {
        return false;
      }
      if (
        mode === 'override' &&
        !benefitsShadow?.querySelector('li.jp-rc-v1-discount-benefit-override .jp-rc-benefit-text[data-jp-rc-v1-dto="true"]')
      ) {
        return false;
      }
    }

    return true;
  }

  const presentationRecoveryTimers = new WeakMap();
  const widgetsRecovering = new WeakSet();

  function recoverWidgetPresentation(widget, options = {}) {
    if (!widget || widgetsRecovering.has(widget)) return;
    const { immediate = false } = options;

    const run = () => {
      presentationRecoveryTimers.delete(widget);
      if (isPresentationIntact(widget)) {
        queueWidgetStateUpdate(widget);
        return;
      }

      widgetsRecovering.add(widget);
      try {
        delete widget.dataset.jpRcPresentationReady;
        initWidgetPresentation(widget);
        scheduleWidgetPresentation(widget);
        scheduleBenefitsEnhancement(widget);
        scheduleLearnMoreEnhancement(widget);
        scheduleSellingPlansEnhancement(widget);
        queueWidgetStateUpdate(widget);
      } finally {
        window.setTimeout(() => widgetsRecovering.delete(widget), 250);
      }
    };

    if (immediate) {
      run();
      return;
    }

    const previous = presentationRecoveryTimers.get(widget);
    if (previous) window.clearTimeout(previous);
    presentationRecoveryTimers.set(widget, window.setTimeout(run, 60));
  }

  function schedulePresentationRecovery(widget) {
    if (!widget) return;
    [0, 80, 200, 500, 1000, 2000].forEach((delay) => {
      window.setTimeout(() => recoverWidgetPresentation(widget), delay);
    });
  }

  function updateWidgetState(widget) {
    if (!widget) return;

    const container = getProductInfoContainer(widget);
    const mode = getPurchaseMode(container);
    const selected = mode === PURCHASE_MODE.SUBSCRIPTION;
    const stateKey = `${mode}:${selected ? '1' : '0'}:v2=${isRechargeWidgetV2(widget) ? '1' : '0'}`;

    widget.classList.add('jp-rc-enhanced', 'jp-rc-hide-onetime');
    widget.classList.toggle('jp-rc-subscription-selected', selected);
    widget.classList.toggle('jp-rc-widget-v2', isRechargeWidgetV2(widget));
    delete widget.dataset.discountLabel;
    getBundleWrapper(container)?.classList.toggle('jp-rc-bundle-inactive', selected);

    if (widget.dataset.jpRcPresentationReady === 'true' && !isPresentationIntact(widget)) {
      recoverWidgetPresentation(widget, { immediate: true });
      return;
    }

    if (widget.dataset.jpRcPresentationReady !== 'true') {
      initWidgetPresentation(widget);
    } else {
      ensureModalidadHeading(widget);
      updateSubscriptionLabel(widget);
      ensureSubscriptionDiscountBadge(widget);
      ensureV2ShadowStyles(widget);
      ensureMaximizaBadge(widget);
      if (isRechargeWidgetV2(widget)) {
        syncBenefitsV2Theme(widget, selected);
      } else {
        applyV1DiscountBenefits(widget);
      }
    }

    if (widget.dataset.jpRcUiState === stateKey) return;
    widget.dataset.jpRcUiState = stateKey;

    document.dispatchEvent(
      new CustomEvent('jp-recharge-widget:updated', {
        bubbles: true,
        detail: { widget, isSubscriptionSelected: selected, purchaseMode: mode },
      })
    );
  }

  function notifyPriceUpdate() {
    if (typeof window.runPriceUpdates === 'function') {
      window.runPriceUpdates();
      return;
    }

    document.dispatchEvent(new CustomEvent('jp-recharge-widget:updated', { bubbles: true }));
  }

  function handleBundleChange(radio) {
    const container = getProductInfoContainer(radio);
    if (container && radio?.value) {
      container.dataset.jpRcLastBundleQty = radio.value;
    }
    applyOnetimePurchase(container);
    getScopedWidgets(container).forEach(queueWidgetStateUpdate);
    notifyPriceUpdate();
  }

  let subscriptionChangeLock = false;

  function handleSubscriptionChange(widget) {
    if (subscriptionChangeLock) return;
    subscriptionChangeLock = true;
    window.setTimeout(() => {
      subscriptionChangeLock = false;
    }, 120);

    const container = getProductInfoContainer(widget);
    applySubscriptionPurchase(container, widget);
    queueWidgetStateUpdate(widget);
    window.setTimeout(() => notifyPriceUpdate(), 150);
    schedulePresentationRecovery(widget);
  }

  function ensureFormsBeforeSubmit(container) {
    if (syncBuyboxV3BeforeSubmit(container)) return;
    syncSellingPlanForPurchaseMode(container);
  }

  function forceInitialOnetimeState(container, widgets) {
    if (!getCustomUnitRadios(container).length) return;

    markInitGrace(container, widgets[0]);
    setPurchaseMode(container, PURCHASE_MODE.BUNDLE_ONETIME);

    const apply = () => {
      if (isSubscriptionMode(container)) return;
      applyOnetimePurchase(container);
      widgets.forEach((widget) => {
        syncRechargePurchaseVisual(widget, 'onetime');
        scheduleWidgetPresentation(widget);
        queueWidgetStateUpdate(widget);
      });
    };

    apply();
    [250, 800, 1800].forEach((delay) => window.setTimeout(apply, delay));
  }

  function initWidget(widget) {
    const shadow = getShadow(widget);
    if (!shadow) return false;

    const container = getProductInfoContainer(widget);

    if (!widget.dataset.jpRcBound) {
      widget.dataset.jpRcBound = 'true';
      markInitGrace(container, widget);

      shadow.addEventListener('click', (event) => {
        const target = event.target;
        if (!(target instanceof Element)) return;

        const subscriptionOption = target.closest('.rc-purchase-option__subscription');
        if (
          subscriptionOption &&
          !target.closest('a') &&
          !target.closest('select') &&
          !target.closest('button')
        ) {
          handleSubscriptionChange(widget);
        }
      });

      shadow.addEventListener('change', (event) => {
        if (purchaseSyncLock) return;

        const target = event.target;
        if (!(target instanceof HTMLInputElement)) return;
        if (target.name !== 'purchaseOption') return;

        if (target.value === 'subscription' && target.checked) {
          if (!isSubscriptionMode(getProductInfoContainer(widget))) {
            handleSubscriptionChange(widget);
          } else {
            scheduleSubscriptionFormSync(getProductInfoContainer(widget));
            queueWidgetStateUpdate(widget);
          }
        } else if (target.value === 'onetime' && target.checked) {
          const container = getProductInfoContainer(widget);
          applyOnetimePurchase(container, { skipWidgetSelect: true });
          queueWidgetStateUpdate(widget);
          notifyPriceUpdate();
        }
      });

      const observer = new MutationObserver((mutations) => {
        if (widgetsRecovering.has(widget)) return;
        if (isWithinInitGrace(widget) || isWithinInitGrace(container)) return;
        if (purchaseSyncLock) return;

        const hasStructuralChange = mutations.some(
          (mutation) => mutation.type === 'childList' && (mutation.addedNodes.length || mutation.removedNodes.length)
        );

        if (hasStructuralChange && !isPresentationIntact(widget)) {
          recoverWidgetPresentation(widget);
          return;
        }

        const scope = getProductInfoContainer(widget);
        if (!isSubscriptionMode(scope) && isSubscriptionSelected(widget)) {
          applyOnetimePurchase(scope);
        }
        queueWidgetStateUpdate(widget);
      });

      observer.observe(shadow, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ['rc-selected', 'rc-not-selected', 'checked'],
      });

      scheduleWidgetPresentation(widget);
      scheduleSellingPlansEnhancement(widget);
      ensureSubContainerLayout(shadow);

      window.setTimeout(() => {
        if (!isSubscriptionMode(container)) {
          applyOnetimePurchase(container);
          syncRechargePurchaseVisual(widget, 'onetime');
        }
        scheduleWidgetPresentation(widget);
        queueWidgetStateUpdate(widget);
      }, INIT_GRACE_MS + 50);
    } else if (!isPresentationIntact(widget)) {
      recoverWidgetPresentation(widget, { immediate: true });
    }

    queueWidgetStateUpdate(widget);
    return true;
  }

  function waitForWidgets(callback) {
    let attempts = 0;
    const maxAttempts = 40;
    const bound = new Set();

    const tick = () => {
      const widgets = getWidgets();
      widgets.forEach((widget) => {
        if (!bound.has(widget) && initWidget(widget)) {
          bound.add(widget);
        }
      });

      if (bound.size > 0 || attempts >= maxAttempts) {
        callback([...bound]);
        return;
      }

      attempts += 1;
      window.setTimeout(tick, 200);
    };

    tick();
  }

  function bindGlobalEvents() {
    document.addEventListener('change', (event) => {
      const { target } = event;
      if (!(target instanceof Element)) return;

      if (target.matches('.custom-one-time-radio') && !target.closest('.jp-buybox-v3')) {
        handleBundleChange(target);
      }
    });

    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const bundleBox = target.closest('.custom-unit-box');
      if (bundleBox) {
        const radio = bundleBox.querySelector('.custom-one-time-radio');
        if (radio && !radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }

    });

    document.addEventListener(
      'submit',
      (event) => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement)) return;
        if (!form.matches('form[is="product-form"], form.main-product-form')) return;
        ensureFormsBeforeSubmit(getProductInfoContainer(form));
      },
      true
    );

    document.addEventListener(
      'click',
      (event) => {
        const target = event.target;
        if (!(target instanceof Element)) return;
        const button = target.closest('.product-form__submit');
        if (!button) return;
        const form = button.closest('form[is="product-form"], form.main-product-form');
        if (!form) return;
        ensureFormsBeforeSubmit(getProductInfoContainer(form));
      },
      true
    );

    document.addEventListener('variant:changed', () => {
      window.setTimeout(() => {
        const widgets = getWidgets();
        const container = widgets[0] ? getProductInfoContainer(widgets[0]) : null;
        widgets.forEach((w) => initWidget(w));
        if (!container) return;
        if (isSubscriptionMode(container)) {
          scheduleSubscriptionFormSync(container);
        } else if (getCustomUnitRadios(container).length) {
          forceInitialOnetimeState(container, widgets);
        }
      }, 200);
    });

    document.addEventListener('cart:updated', () => {
      getWidgets().forEach((widget) => schedulePresentationRecovery(widget));
    });

    if (typeof FoxTheme !== 'undefined' && FoxTheme.pubsub) {
      FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, function () {
        document.dispatchEvent(new CustomEvent('variant:changed'));
      });

      if (FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate) {
        FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, function () {
          getWidgets().forEach((widget) => schedulePresentationRecovery(widget));
        });
      }
    }
  }

  function init() {
    if (!document.querySelector('recharge-subscription-widget')) return;

    bindGlobalEvents();

    waitForWidgets((widgets) => {
      const container = widgets[0] ? getProductInfoContainer(widgets[0]) : document;
      forceInitialOnetimeState(container, widgets);
    });
  }

  window.jpRechargeWidget = {
    getWidgets,
    applyOnetimePurchase,
    applySubscriptionPurchase,
    syncQuantities,
    syncSellingPlanForPurchaseMode,
    isSubscriptionSelected: () => getWidgets().some((w) => isSubscriptionSelected(w)),
    getPurchaseMode,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
